<script lang="ts" setup></script>

<template>
  <div class="h-px w-full bg-border"></div>
</template>

<style lang="scss"></style>
